import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  pageControlBar: {
    composes: 'flex-row',
    backgroundColor: colors.backgroundGray,
    minWidth: 400,
    border: `1px solid ${colors.gunMetal}`,
    borderTop: 'none',
    margin: '0 auto',
    padding: 10,
    justifyContent: 'center'
  }
}

export const useStyles = createUseStyles(style)
